module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.9c46095.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/blossom-u/fonts/Montserrat-Regular.ttf
// module id = 507
// module chunks = 0